import type { ReactNode } from 'react'

export function GrayChip({
  children,
  paddingClass = 'px-3',
  className = '',
}: {
  children: ReactNode
  paddingClass?: string
  className?: string
}) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-lg border border-[rgb(0_0_0/5%)] bg-[#ebebeb] py-[3px] text-body-sm font-medium whitespace-nowrap text-black-400 ${paddingClass} ${className}`}
    >
      {children}
    </span>
  )
}
